module.exports = __webpack_public_path__ + "static/media/zoom-link.ae68b7be.svg";